// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MocaFlag-module__flag___N_2ld {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border: 1px solid #fecaca;
  border-radius: 4px;
  background: #fef2f2;
  font-size: 13px;
  font-weight: 600;
  color: #991b1b;
}

.MocaFlag-module__icon___VJtV9 {
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/MocaFlag/MocaFlag.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":[".flag {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 10px;\n  border: 1px solid #fecaca;\n  border-radius: 4px;\n  background: #fef2f2;\n  font-size: 13px;\n  font-weight: 600;\n  color: #991b1b;\n}\n\n.icon {\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flag": `MocaFlag-module__flag___N_2ld`,
	"icon": `MocaFlag-module__icon___VJtV9`
};
module.exports = ___CSS_LOADER_EXPORT___;
